import React from "react"
import PropTypes from "prop-types"

import ErrorText from "@irati/ui/src/ErrorText"
import {FormattedMessage, injectIntl} from "@irati/utils/lang"
import getErrorCode from "../helpers/getErrorCode"


const Error = ({apollo, formatMessage}) => {
  const defaultError = formatMessage({id: "insights.errors.default"})
  return (
    <ErrorText>
      <FormattedMessage id={`error.${getErrorCode(apollo.error)}`} defaultMessage={defaultError} />
    </ErrorText>
  )
}

Error.propTypes = {
  apollo: PropTypes.object.isRequired,
  formatMessage: PropTypes.func.isRequired
}

export default injectIntl(Error)
